import { render, staticRenderFns } from "./checkboxgroup.vue?vue&type=template&id=778b5ff1&"
import script from "./checkboxgroup.vue?vue&type=script&lang=js&"
export * from "./checkboxgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports